<div id="kiosk-root" [@routerTransition]="getRouterState(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
